export default __webpack_public_path__ + "static/media/aws.2c1f65c5.svg";